import store from '@/store'
const onboardingMenuConfig = {
    showRoutes: [
        '/provider',
        '/bank',
        `/company/register/${store.state.user.cnpjId}/message`,
        `/user/company/${store.state.user.cnpjId}`,
        '/settings',
        '/buyers',
    ],    
}

export default onboardingMenuConfig